// extracted by mini-css-extract-plugin
module.exports = {"action":"styles_action__3vag1"};